export function toE164(phone: string): string {
  const trimmed = phone.trim()
  if (trimmed.startsWith('+')) return '+' + trimmed.slice(1).replace(/\D/g, '')
  return '+' + trimmed.replace(/\D/g, '')
}

export interface BookingFormInput {
  name: string
  phone: string
  partySize: number
}
export interface BookingFormResult {
  valid: boolean
  errors: { name?: string; phone?: string; partySize?: string }
}

/** E.164 laxo: + y 10–15 dígitos (igual que /api/online-orders). */
const E164 = /^\+\d{10,15}$/

export function validateBookingForm(input: BookingFormInput): BookingFormResult {
  const errors: BookingFormResult['errors'] = {}
  if (!input.name.trim()) errors.name = 'reservationErrorNameRequired'
  if (!E164.test(toE164(input.phone))) errors.phone = 'reservationErrorPhoneInvalid'
  if (!Number.isInteger(input.partySize) || input.partySize < 1) errors.partySize = 'reservationErrorPartyInvalid'
  return { valid: Object.keys(errors).length === 0, errors }
}

/** Mapea (status, error) de las APIs de reservas a una clave i18n de
 *  public.microsite, para mostrarle al cliente un mensaje claro. */
export function reservationErrorKey(status: number, code: string): string {
  if (code === 'no_availability') return 'reservationErrorNoAvailability'
  if (code === 'invalid_slot') return 'reservationErrorInvalidSlot'
  if (code === 'party_too_large') return 'reservationErrorPartyTooLarge'
  if (code === 'too_many_reservations') return 'reservationErrorTooMany'
  // Cuota de reservas del plan gratis (20/mes) alcanzada — degradación
  // amable, nunca un 500 (ver checkQuota en app/api/reservations/route.ts).
  if (code === 'reservations_quota_reached') return 'reservationErrorQuotaReached'
  if (status === 404) return 'reservationErrorUnavailable'
  if (status === 409) return 'reservationErrorNoAvailability'
  return 'reservationErrorGeneric'
}
